"use strict";

/**
 * DGF-4877: gives the surface's Klarna placement a new amount and has Klarna redraw it.
 * @param {string} surface - "basket" or "product", as components/klarna/klarnaPlacement.isml names it
 * @param {number} purchaseAmount - amount in minor units; 0 hides the message
 * @param {jQuery} [$scope] - only the placement inside this element, so a quick view leaves the PDP's alone
 */
function updatePlacement(surface, purchaseAmount, $scope) {
    const selector = `.js-klarna-messaging-${surface}`;
    const $messaging = $scope ? $scope.find(selector) : $(selector);
    if (!$messaging.length) {
        return;
    }

    $messaging.toggleClass("d-none", !(purchaseAmount > 0));
    $messaging.find("klarna-placement").attr("data-purchase-amount", purchaseAmount || 0);

    window.KlarnaOnSiteService = window.KlarnaOnSiteService || [];
    window.KlarnaOnSiteService.push({ eventName: "refresh-placements" });
}

/**
 * Client-side twin of klarnaMessagingHelpers.getProductPurchaseAmount.
 * @param {Object} price - the product's price model from a Product-Variation response
 * @returns {number} the sales price in minor units (the lowest for a range), 0 when there isn't one
 */
function getProductPurchaseAmount(price) {
    let sales = null;
    if (price && price.type === "range") {
        sales = price.min && price.min.sales;
    } else if (price && price.type !== "tiered") {
        sales = price.sales;
    }
    return sales && sales.value > 0 ? Math.round(sales.value * 100) : 0;
}

module.exports = {
    updatePlacement,
    getProductPurchaseAmount
};
